
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/tour/[id]",
      function () {
        return require("private-next-pages/[lang]/tour/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/tour/[id]"])
      });
    }
  